// import React from "react";
// import "../Styles/Footer.css"; // for styles

// export default function Footer() {
//   return (
//     <footer className="footer">
//       <p>
//         <span className="label">Support :</span>{" "}
//         <a href="tel: +91 8828412820" className="link"> +91 8828412820 |</a> 
//         <a href="mailto:mmstnt22@gmail.com"className="link">mmstnt22@gmail.com </a>
//       </p>
//     </footer>
//   );
// }
import React from "react";

export default function Footer() {
  const footerStyle = {
    backgroundColor: "#f9f9f9",
    padding: "8px 20px",
    textAlign: "center",
    fontSize: "14px",
    color: "#555",
    borderTop: "1px solid #ddd",
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    zIndex: 1000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };

  const labelStyle = { fontStyle: "italic", color: "#666" };
  const linkStyle = { color: "#1e88e5", textDecoration: "none", marginLeft: "5px", fontWeight: "bold" };

  return (
    <footer style={footerStyle}>
      <p style={{ margin: 0 }}>
        <span style={labelStyle}>Support :</span>{" "}
        <a href="tel:+918828412820" style={linkStyle}>+91 8828412820 |</a>
        <a href="mailto:info@mmstourism.com" style={linkStyle}>info@mmstourism.com</a>
      </p>
    </footer>
  );
}
